import {
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from "@angular/common/http";
import { authInterceptor } from "./core/interceptors/auth/auth.interceptor";
import { errorInterceptor } from "./core/interceptors/error/error.interceptor";
import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideAnimations } from "@angular/platform-browser/animations"; // NOSONAR - AnimationModule API deprecated in Angular 20.2; still required by Material/CDK until v23
import { provideFlatpickrDefaults } from 'angularx-flatpickr';
import { provideHotToastConfig } from '@ngxpert/hot-toast';

import { provideRouter } from "@angular/router";
import { provideStore } from "@ngrx/store";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { routes } from "./app.routes";
import { provideRuntimeConfigInitializer } from "./core/initializers/runtime-config.initializer";
import { cpUserReducer } from "./core/state/user/user.reducer";
import { indexReducer } from "./store/index.reducer";
import { AppService } from "./services/app.service";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: provideRuntimeConfigInitializer,
      multi: true,
    },
    provideAnimations(), // NOSONAR - AnimationModule API deprecated in Angular 20.2; still required by Material/CDK until v23
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),

    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
    provideStore({ index: indexReducer, cpUsers: cpUserReducer }),
    AppService,
    provideFlatpickrDefaults(),
    provideHotToastConfig({
      position: 'top-right',
      duration: 3000,
      autoClose: true,
      dismissible: true,
    }),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: "en",
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ),
  ],
};
